/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_ScanInputs */

const en_audio_embed_export_scan = /** @type {(inputs: Audio_Embed_Export_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan tracks`)
};

const fr_audio_embed_export_scan = /** @type {(inputs: Audio_Embed_Export_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pistes de numérisation`)
};

const de_audio_embed_export_scan = /** @type {(inputs: Audio_Embed_Export_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanspuren`)
};

const it_audio_embed_export_scan = /** @type {(inputs: Audio_Embed_Export_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracce di scansione`)
};

const ru_audio_embed_export_scan = /** @type {(inputs: Audio_Embed_Export_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сканирование треков`)
};

const es_audio_embed_export_scan = /** @type {(inputs: Audio_Embed_Export_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pistas de escaneo`)
};

const zh_cn2_audio_embed_export_scan = /** @type {(inputs: Audio_Embed_Export_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扫描轨迹`)
};

const ja_audio_embed_export_scan = /** @type {(inputs: Audio_Embed_Export_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スキャントラック`)
};

const hi_audio_embed_export_scan = /** @type {(inputs: Audio_Embed_Export_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैक स्कैन करें`)
};

const pt_pt2_audio_embed_export_scan = /** @type {(inputs: Audio_Embed_Export_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastreamento de trilhas`)
};

/**
* | output |
* | --- |
* | "Scan tracks" |
*
* @param {Audio_Embed_Export_ScanInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_scan = /** @type {((inputs?: Audio_Embed_Export_ScanInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_ScanInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_scan(inputs)
	if (locale === "de") return de_audio_embed_export_scan(inputs)
	if (locale === "it") return it_audio_embed_export_scan(inputs)
	if (locale === "ru") return ru_audio_embed_export_scan(inputs)
	if (locale === "es") return es_audio_embed_export_scan(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_scan(inputs)
	if (locale === "ja") return ja_audio_embed_export_scan(inputs)
	if (locale === "hi") return hi_audio_embed_export_scan(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_scan(inputs)
	return en_audio_embed_export_scan(inputs)
});